export default "__VITE_ASSET__d1531770__"